import { render, staticRenderFns } from "./Committee.vue?vue&type=template&id=687c0682"
import script from "./Committee.vue?vue&type=script&lang=js"
export * from "./Committee.vue?vue&type=script&lang=js"
import style0 from "./Committee.vue?vue&type=style&index=0&id=687c0682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports